import React, { useCallback, useContext, useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import classNames from 'classnames';
import { $l } from 'choerodon-ui/pro/lib/locale-context';
import Icon from '../../../icon';
import TabsContext from '../../TabsContext';
import ItemTitle from './ItemTitle';
const Item = function Item(props) {
    const { prefixCls, tabDraggable, defaultChangeable } = useContext(TabsContext);
    const selfPrefixCls = `${prefixCls}-customization-group-item`;
    const { suffix, record, index, records, provided, snapshot, defaultKey } = props;
    const sort = record.get('sort');
    const [isHover, setIsHover] = useState(false);
    const handleMouseEnter = useCallback(() => setIsHover(true), []);
    const handleMouseLeave = useCallback(() => setIsHover(false), []);
    const { isDragging } = snapshot;
    useEffect(() => {
        setIsHover(false);
    }, [sort]);
    function getIcon() {
        if (tabDraggable) {
            const iconProps = { ...provided.dragHandleProps, style: { cursor: 'move' } };
            return (React.createElement(Icon, Object.assign({ className: `${selfPrefixCls}-drag-icon`, type: "baseline-drag_indicator" }, iconProps)));
        }
    }
    const divProps = tabDraggable ? {
        ref: provided.innerRef,
        ...provided.draggableProps,
        className: classNames({ [`${selfPrefixCls}-dragging`]: isDragging }),
    } : {};
    return (React.createElement("div", Object.assign({}, divProps),
        React.createElement("div", { className: classNames(selfPrefixCls, { [`${selfPrefixCls}-hover`]: isHover }), onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave },
            React.createElement("div", { className: `${selfPrefixCls}-content` },
                getIcon(),
                React.createElement("div", { className: `${selfPrefixCls}-title` },
                    React.createElement("span", { className: `${selfPrefixCls}-title-text` },
                        React.createElement(ItemTitle, { record: record, provided: tabDraggable ? provided : undefined }),
                        defaultChangeable && defaultKey === record.get('key') && (React.createElement("span", { className: `${selfPrefixCls}-title-default` }, $l('Tabs', 'default'))))),
                suffix(record, index, records)))));
};
Item.displayName = 'Item';
export default observer(Item);
